import React from 'react';
import { Chip, Typography } from '@mui/material';

import DataTableModule from '@/__core/layout/module/DataTableModule';

import { InventoryReportRow } from '../types';

interface ReportListProps {
  rows: InventoryReportRow[];
  onSelectRow: (row: InventoryReportRow) => void;
}

const statusColor = (status: string): 'default' | 'warning' | 'success' | 'info' | 'error' => {
  switch (status) {
    case 'posted':
      return 'success';
    case 'draft':
      return 'warning';
    case 'approved':
      return 'info';
    default:
      return 'default';
  }
};

const reportTypeLabel = (reportType: string) => {
  switch (reportType) {
    case 'monthly_receipts':
      return 'Nhập theo tháng';
    case 'material_ratio':
      return 'Tỷ lệ vật tư / doanh số';
    default:
      return reportType;
  }
};

export default function ReportList({ rows, onSelectRow }: ReportListProps) {
  const columns: Array<{
    id: string;
    label: string;
    width?: string;
    align?: 'left' | 'center' | 'right';
    render?: (_: unknown, row: InventoryReportRow) => React.ReactNode;
  }> = [
    { id: 'status', label: 'Trạng thái', width: '140px', render: (_: unknown, row: InventoryReportRow) => <Chip size='small' color={statusColor(row.status)} label={row.status} /> },
    { id: 'report_type', label: 'Loại báo cáo', width: '200px', render: (_: unknown, row: InventoryReportRow) => reportTypeLabel(row.report_type) },
    { id: 'code', label: 'Mã báo cáo', width: '150px', render: (_: unknown, row: InventoryReportRow) => <Typography sx={{ fontWeight: 600 }}>{row.code}</Typography> },
    { id: 'name', label: 'Tên báo cáo', width: '260px' },
    { id: 'reference', label: 'Tham chiếu', width: '180px' },
    { id: 'qty', label: 'Số liệu', width: '140px', align: 'right', render: (_: unknown, row: InventoryReportRow) => row.qty.toLocaleString('vi-VN') },
    { id: 'amount', label: 'Giá trị', width: '160px', align: 'right', render: (_: unknown, row: InventoryReportRow) => row.amount.toLocaleString('vi-VN') },
    { id: 'company_name', label: 'Công ty', width: '220px' },
  ];

  return (
    <DataTableModule
      data={rows}
      columns={columns}
      onRowSelect={() => undefined}
      onSelectAll={() => undefined}
      onRowClick={(row) => onSelectRow(row as InventoryReportRow)}
      getRowId={(row) => (row as InventoryReportRow).id}
      isRowSelected={() => false}
      areAllRowsSelected={false}
      areSomeRowsSelected={false}
      leftFilterWidth={0}
      showCheckbox={false}
    />
  );
}